import { TrelloStorage } from '@trello/storage';
import { getLastMemberId } from '../last-session';

const NOTIFICATION_FILTER_KEY_PREFIX = 'notificationFilterState';

export enum NotificationFilter {
  VISIBILITY_ALL = 'VISIBILITY_ALL',
  VISIBILITY_UNREAD = 'VISIBILITY_UNREAD',
}

export interface NotificationFilterState {
  visibilityFilter: string;
}

const initialState: NotificationFilterState = {
  visibilityFilter: NotificationFilter.VISIBILITY_UNREAD,
};

export const getNotificationFilterStateKey = () => {
  const idMe = getLastMemberId();

  return `${NOTIFICATION_FILTER_KEY_PREFIX}-${idMe}`;
};

export const getNotificationVisibilityFilter = (): string => {
  const idMe = getLastMemberId();
  if (!TrelloStorage.isEnabled() || !idMe) {
    return initialState.visibilityFilter;
  }

  const key = getNotificationFilterStateKey();
  const notificationFilter = TrelloStorage.get(key);

  if (!notificationFilter) {
    TrelloStorage.set(key, initialState);

    return initialState.visibilityFilter;
  }

  return notificationFilter.visibilityFilter;
};

export const setNotificationVisibilityFilter = (value: NotificationFilter) => {
  const idMe = getLastMemberId();
  if (!TrelloStorage.isEnabled() || !idMe) {
    return;
  }

  const key = getNotificationFilterStateKey();
  TrelloStorage.set(key, {
    ...(TrelloStorage.get(key) || initialState),
    visibilityFilter: value,
  });
};

export const isNotificationFilterVisibilityAll = () =>
  getNotificationVisibilityFilter() === NotificationFilter.VISIBILITY_ALL;

export const isNotificationFilterVisibilityUnread = () =>
  getNotificationVisibilityFilter() === NotificationFilter.VISIBILITY_UNREAD;
